import { Component } from 'react';
import TextWithExternalLink from 'common/components/TextWithExternalLink';
import { DateTime } from 'common/utils/date';

class ActionsDisplay extends Component {
  constructor(props) {
    super();
    this.state = { ...props };
    this.completeTakeaway = this.completeTakeaway.bind(this);
  }

  completeTakeaway(e, id, completedAt) {
    const complete = e.target.checked;
    // prettier-ignore
    $.ajax({ // eslint-disable-line no-undef
      url: `/api/v1/coaching/takeaway/${id}`,
      dataType: 'json',
      cache: false,
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify({ complete }),
      success: function (takeaway) {
        this.setState({ ...takeaway });
      }.bind(this),
      error: function () {
        this.setState({ completedAt: !!completedAt });
      }.bind(this),
    });
  }

  render(
    {
      id,
      text,
      completedAt,
      completedBy,
      createdAt,
      createdBy,
      sessionId,
      categoryName,
      private: isPrivate,
    } = this.state
  ) {
    return (
      <div className="actions-and-kudo-display">
        <div className="action-card" data-completed={!!completedAt}>
          <div className="takeaway-info">
            <input
              id={`takeaway-${id}`}
              className="takeaway-checkbox"
              type="checkbox"
              onChange={e => {
                this.completeTakeaway(e, id, completedAt);
              }}
              defaultChecked={!!completedAt}
            />
            <label htmlFor={`takeaway-${id}`} className="fa fa-check" />
            <span className="takeaway-text">
              <TextWithExternalLink text={text} />
            </span>
          </div>
          <div className="takeaway-details">
            <span className="flex align-center">
              <span className="takeaway-category">{categoryName}</span>
              {isPrivate ?
                <i className="fa fa-lock padding-left-small" />
              : ''}
            </span>
            <a
              className="takeaway-session-link"
              href={`/one_on_ones/${sessionId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to session
            </a>
          </div>
        </div>
        <div className="takeaway-status">
          <span>
            {completedAt ? completedBy : createdBy} •{' '}
            {DateTime.fromISO(completedAt || createdAt).toLocaleString(
              DateTime.DATETIME_MED_WITH_SECONDS
            )}
          </span>
        </div>
      </div>
    );
  }
}

export default ActionsDisplay;
